//service
import http from "./httpService";
import config from "./config"
import { decodeToken } from "../utils/decodeToken";


//register user
// export const registerUser = user => {
//     return http.post(
//         `${config.apiAddress}register/`,
//         JSON.stringify(user)
//     );
// };



export const registerUser = user => {
    return http.post(
        `${config.apiAddress}register/`,
        JSON.stringify(user)
    );
};

export const loginUsers = (user) => {
    return http.post(
        `${config.apiAddress}login/`,
        JSON.stringify(user)
    );
};


export const userInformation = () => {
    var user = {}
    const token = localStorage.getItem("loginToken");
    const decodedToken = decodeToken(token);
    user = decodedToken.message
    return http.post(
        `${config.apiAddress}userInformation/`,
        JSON.stringify(user)
    );
};


export const updateUserInformation = (info) => {
    console.log(1111);
    var user = {}
    const token = localStorage.getItem("loginToken");
    const decodedToken = decodeToken(token);
    user = decodedToken.message
    info.username=user.username
    info.password=user.password
    return http.post(
        `${config.apiAddress}updateUserInformation/`,
        JSON.stringify(info)
    );
};


export const checkIsCompleteInfo = (username) => {
    return http.get(
        `${config.apiAddress}checkUser/${username}`
    );
};